import { useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectDocument } from '../documentSlice';
import { impossible } from '../../../app/Utils';
import { generateDocBlock } from '../documentsApi';
import { GenerateButton } from '../../../app/components/GenerateButton';
import { SectionContent } from '../SectionContent';
import { useCurrentEditor } from '@tiptap/react';

const SectionGenerator = (props: { sectionId: string }) => {
    const { sectionId } = props
    const dispatch = useAppDispatch()
    const { header } = useAppSelector(selectDocument).doc ?? impossible()
    const { id: docId } = header
    const { editor } = useCurrentEditor()

    const [saving, setSaving] = useState(false)

    const handleGenerateClick = async () => {
        setSaving(true)
        try {
            const block = await dispatch(generateDocBlock({
                sectionId,
                docId,
                description: '',
            })).unwrap()

            if (editor) {
                editor.commands.setContent(block.description)
            }
        } catch (error) {
            // setError(error as APIError)
        } finally {
            setSaving(false)
        }
    }

    return <GenerateButton
        loading={saving}
        onClick={handleGenerateClick}
    />
}

export const ResponsibilitiesSectionWrapper = (props: { sectionId: string }) => {
    const { sectionId } = props

    const genBtn = useMemo(() => <SectionGenerator sectionId={sectionId} />, [sectionId])

    return <SectionContent sectionId={sectionId} actions={genBtn} />
}

